import { render } from "./MailConfigurationFormView.vue?vue&type=template&id=689b76b4&scoped=true"
import script from "./MailConfigurationFormView.vue?vue&type=script&lang=js"
export * from "./MailConfigurationFormView.vue?vue&type=script&lang=js"

import "./MailConfigurationFormView.vue?vue&type=style&index=0&id=689b76b4&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689b76b4"]])

export default __exports__